export default __webpack_public_path__ + "static/media/4.3c934bc8.svg";